// @ts-nocheck
import {IntlShape} from "react-intl";
import {PersonGroupExt} from "../../../cuba/entities/base/base$PersonGroupExt";

export const getTableRegisterOrderFields = (intl: IntlShape, selectedElement: any, setSelectedElement: any) => [
  {
    title: intl.formatMessage({ id: "personGroup" }),
    dataIndex: "fullName",
    key: "fullName",
    render: (_, record: PersonGroupExt) => record?._instanceName,
  },
  {
    title: intl.formatMessage({ id: "organization" }),
    dataIndex: "organization",
    key: "organization",
    render: (_, record: PersonGroupExt) => record?.currentAssignment?.organizationGroup?._instanceName,
  },
  {
    title: intl.formatMessage({ id: "employee.positionName" }),
    dataIndex: "positionName",
    key: "positionName",
    render: (_, record: PersonGroupExt) => record?.currentAssignment?.positionGroup?._instanceName,
  },
];
